import {CHANGE_TOPICS} from 'src/pages/category/store/actions/topics';
import {createLoggerMiddleware} from 'src/shared/logger/middleware';

export const logger = createLoggerMiddleware({
  component: 'XHS-PAGE-CATEGORY',
  page: 'category',
  types: [
    CHANGE_TOPICS,
  ],
});
